import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import LoginPage from './component/login/logininicio';
import HomePage from './component/Home/HomePage';
import ReporteUsuario from './component/ReporteUsuario/ReporteUsuario'; // Importa el nuevo componente ReporteUsuario
import ReporteClientes from './component/ReporteClientes/ReporteClientes'; // Importa el nuevo componente ReporteClientes
import ReporteArea from './component/ReporteArea/ReporteArea'; // Importa el nuevo componente ReporteArea
import MisHoras from './component/MisHoras/MisHoras'; // Importa el componente MisHoras
import GestionUsuariosPage from './component/GestionUsuarios/GestionUsuariosPage'; // Importa la página de gestión de usuarios
import Perfil from './component/Perfil/Perfil'; // Importa la página de Mi Perfil
import { history } from './history';
import { rehydrateSession } from './actions/index.js'; // Asegúrate de importar la acción rehydrateSession
import PrivateRoute from './utils/PrivateRoute.js';
import './datepicker-theme.css'; // Tema unificado de los calendarios (Reportes + Mis Horas)

// cons App es el componente principal de la aplicación donde se definen las rutas de la aplicación para navegar entre las páginas
const App = () => {
  const dispatch = useDispatch();
  
  // Usa el hook useEffect para rehidratar la sesión del usuario al cargar la aplicación
  useEffect(() => {
    const token = localStorage.getItem('token');
    // Si hay un token en el almacenamiento local, rehidrata la sesión del usuario
    if (token) {
      dispatch(rehydrateSession(token));
    }
  }, [dispatch]);

  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/login" />} />
        <Route path="/login" component={LoginPage} />
        <PrivateRoute path="/home" component={HomePage} />
         <PrivateRoute path="/reportes/usuario" component={ReporteUsuario} /> {/* Nueva ruta para reporte de usuario */}
        <PrivateRoute path="/reportes/clientes" component={ReporteClientes} /> {/* Nueva ruta para reporte de clientes */}
        <PrivateRoute path="/reportes/area" component={ReporteArea} /> {/* Nueva ruta para reporte de área */}
        <PrivateRoute path="/mishoras" component={MisHoras} /> {/* Ruta para MisHoras */}
        <PrivateRoute path="/perfil" component={Perfil} /> {/* Ruta para Mi Perfil */}
        <PrivateRoute path="/usuarios" component={GestionUsuariosPage} /> {/* Ruta para gestión de usuarios */}
      </Switch>
    </Router>
  );
};

export default App;